export const NumberGenerationRptConstants ={
    GETALL_REQUEST: 'NumberGeneration_GETALL_REQUEST',
    GETALL_SUCCESS: 'NumberGeneration_GETALL_SUCCESS',
    GETALL_FAILURE: 'NumberGeneration_GETALL_FAILURE'
}